import React, { createContext } from 'react';

export const CurrentUserContext = createContext();
